import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild, ViewEncapsulation } from "@angular/core";
import { AmazonService } from "../../../services/amazon.service";
import { AmazonStoreCredentials } from "../../../objects/amazon/AmazonStoreCredentials";
import { Router } from "@angular/router";
import { ResponseError } from "../../../objects/common/responseError";
import { AmazonSignFormComponent } from "../sign/amazon-sign-form-modal.component";
import { SellerStatus } from "../../../objects/amazon/seller";


@Component({
    selector: 'amazon-credentials',
    templateUrl: './amazon-credentials.component.html',
    encapsulation: ViewEncapsulation.None,
    moduleId: module.id.toString()
})
export class AmazonCredentialsComponent implements OnInit {
    public storeCredentials: AmazonStoreCredentials = new AmazonStoreCredentials();
    public error: ResponseError;
    public isProcessing: boolean = false;
    @ViewChild('signModal')
    public signForm: AmazonSignFormComponent;
    public idToBlur: string = "amazon-credentials";
    public title: string = "Store Credentials";
    public hasCredentialsError = false;
    public errorString: string = '';
    public credentialsErrorType = CredentialsErrorType;
    public credentialsError: CredentialsErrorType;

    public constructor(private renderer: Renderer2, private amazonService: AmazonService, private router: Router) {
    }

    public ngOnInit() {
        if (this.amazonService.seller.Stores && this.amazonService.seller.Stores.length > 0) {
            this.storeCredentials = this.amazonService.seller.Stores[0];
        }
        const el = document.querySelector("#amazonInfo");

        if (el) {
            el.scrollTop = 0
        }

    }

    public createStore(valid: boolean): void {
        if (!valid)
            return;

        this.amazonService.seller.Stores[0] = this.storeCredentials;

        this.amazonService.setCurrentSeller(this.amazonService.seller).then(resp => {
            this.exportStoreProducts();
        }).catch(err => {
            this.isProcessing = false
        });
    }

    public goToStore(): void {
        let store = this.amazonService.seller.Stores[0];
        this.router.navigate([`amazon/info/${this.amazonService.seller.Id}/store/${store.Id}/products`]);
    }

    public exportStoreProducts() {
        this.isProcessing = true;
        this.title = this.amazonService.seller.Stores[0].StoreName;
        this.amazonService.exportAndSaveProducts(this.amazonService.seller.Id, this.amazonService.seller.Stores[0].Id).then(resp => {
            this.isProcessing = false;

            // if (this.amazonService.seller.PoaNumber == SellerStatus.NotStarted && !hasSignModalShown) {
            //     this.signForm.show();
            //     return;
            // }

            this.goToStore();
        }).catch(err => {
            this.isProcessing = false;
            this.hasCredentialsError = true;

            if (err.Errors && err.Errors.length > 0 && err.Errors[0].Value && err.Errors[0].Value.length > 0)
                this.errorString = err.Errors[0].Value[0];
            else return;
            // let errorArray = this.errorString.split(' ');
            if (this.errorString.includes('Marketplace'))
                this.credentialsError = CredentialsErrorType.Marketplace;

            if (this.errorString.includes('seller'))
                this.credentialsError = CredentialsErrorType.SellerID;

            if (this.errorString.includes('MWS'))
                this.credentialsError = CredentialsErrorType.MWSAuthToken;

            // Request is throttled
            if (this.errorString.includes( 'throttled')){
                this.credentialsError = CredentialsErrorType.Throttled;
                this.errorString ='Something went wrong, please wait for a few seconds and try again';
            }


        });
    }

    public userNavigate(routing: string) {
        this.amazonService.setPrevUrl(this.router.url);
        this.router.navigate([routing]);
    }


}

export enum CredentialsErrorType {
    Marketplace = 0,
    SellerID = 1,
    MWSAuthToken = 2,
    Throttled = 3
}


// WEBPACK FOOTER //
// ./app/components/amazon/store-credentials/amazon-credentials.component.ts